import React from "react";
import { createBrowserRouter } from "react-router-dom";
import KYCsteps from "../components/pages/KYCsteps";
import RequestOTP from "../components/pages/requestOTP";
import VerifyOTP from "../components/pages/verifyOTP";
import Error from "../components/shared/error/errorComponent";
import { ROUTES_VARIANT } from "constants/routesVariant";
import AppShell from "@shared/appShell";
import { KYCCompleted } from "components/pages/KYCsteps/ocrSteps/pages/KYCCompleted";
import NameMatchTester from "components/pages/nameMatchTester";
import AdminAppShell from "components/pages/admin/AdminAppShell";
import VerifiedKycUsersPage from "components/pages/admin/VerifiedKycUsersPage";
import VerifiedKycDetailPage from "components/pages/admin/VerifiedKycDetailPage";
import AdminKycVerificationDetailPage from "components/pages/admin/AdminKycVerificationDetailPage";

// Define the routes for the application
const ROUTES = createBrowserRouter([
  {
    path: `/${ROUTES_VARIANT.NAME_MATCH_TESTER}`,
    element: <AdminAppShell />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <NameMatchTester />,
        errorElement: <Error />,
      },
    ],
  },
  {
    path: `/${ROUTES_VARIANT.VERIFIED_KYC_USERS}`,
    element: <AdminAppShell />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <VerifiedKycUsersPage />,
        errorElement: <Error />,
      },
      {
        path: ":customerSource/:customerId/verification",
        element: <AdminKycVerificationDetailPage />,
        errorElement: <Error />,
      },
      {
        path: ":customerSource/:customerId",
        element: <VerifiedKycDetailPage />,
        errorElement: <Error />,
      },
    ],
  },
  {
    path: "/",
    element: <AppShell />,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <RequestOTP />,
        errorElement: <Error />,
      },
      {
        path: `${ROUTES_VARIANT.PROCESS}`,
        element: <KYCsteps />,
        errorElement: <Error />,
      },
      {
        path: `${ROUTES_VARIANT.VERIFY_OTP}`,
        element: <VerifyOTP />,
        errorElement: <Error />,
      },
      {
        path: `${ROUTES_VARIANT.FINISH}`,
        element: <KYCCompleted />,
        errorElement: <Error />,
      },
    ],
  },
]);

export default ROUTES;
